export function getUser(state) {
  return state.user;
}



/** WEBPACK FOOTER **
 ** ./src/core/user/selectors.js
 **/